import { render } from "./KiesseDuplicate.vue?vue&type=template&id=4469ce5e&ts=true"
import script from "./KiesseDuplicate.vue?vue&type=script&lang=ts"
export * from "./KiesseDuplicate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__